import { render, staticRenderFns } from "./aiNum.vue?vue&type=template&id=c7a99882&scoped=true"
import script from "./aiNum.vue?vue&type=script&lang=js"
export * from "./aiNum.vue?vue&type=script&lang=js"
import style0 from "./aiNum.vue?vue&type=style&index=0&id=c7a99882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7a99882",
  null
  
)

export default component.exports